import { types, getParent } from 'mobx-state-tree';

const Actions = types
  .model('Actions', {
    status: types.optional(types.string, ''),
    quantity: types.optional(types.string, ''),
    template: types.optional(types.string, ''),
    profit: types.optional(types.string, ''),
    breakEven: types.optional(types.string, ''),
    profitType: types.optional(types.string, '1'),
    monitoringStatus: types.optional(types.string, '')
  })
  .views(self => ({
    get templateList() {
      return getParent(self).templateList;
    },
    get templateName() {
      const template = self.templateList.find(t => t.id === self.template) || '';
      return template ? template.name : '';
    },
    get payload() {
      return {
        status: self.status ? parseInt(self.status,10) : undefined,
        quantity: self.quantity ? parseInt(self.quantity,10) : undefined,
        templateId: self.template || undefined,
        profit: self.profit ? parseFloat(self.profit) : undefined,
        breakEven: self.breakEven ? parseFloat(self.breakEven) : undefined,
        profitType: self.profit ? parseInt(self.profitType, 10) : undefined,
        monitoringStatus: self.monitoringStatus ? parseInt(self.monitoringStatus, 10) !== 0 : undefined
      };
    },
    get isBtnDisabled() {
      return self.status === '' && self.quantity === '' && self.template === '' && self.profit === '' && self.breakEven === '' && self.monitoringStatus === '';
    },
  }))
  .actions(self => ({
    setTemplate(value) {
      self.template = value;
    },
    setStatus(value) {
      self.status = value;
    },
    setQuantity(value) {
      self.quantity = value;
    },
    setProfitType(value) {
      self.profitType = value;
    },
    setProfit(value) {
      self.profit = value;
    },
    setBreakEven(value) {
      self.breakEven = value;
    },
    setMonitoringStatus(value) {
      self.monitoringStatus = value;
    },
    clear() {
      self.status = '';
      self.quantity = '';
      self.template = '';
      self.profit = '';
      self.breakEven = '';
      self.profitType = '1';
      self.monitoringStatus = '';
    },
  }));

export default Actions;
